export default {
    SET_SELECT_CLUB_MANAGER(state,ClubManager){
        state.selectClubManager = ClubManager
    },
    SET_RESULT(state,result){
        state.Result = result
    },
    SET_EDIT_CLUB_MANAGER(state,editClubManager){
        state.editClubManager = editClubManager
    },
}
